export const USER_TYPE = {
  PRO: "PRO",
  PART: "PART",
};
